import React from 'react';
export function Credibility() {
  return <section className="mb-24" data-id="element-47">
      <h2 className="text-[28px] sm:text-[32px] md:text-[36px] font-semibold text-[#1B2951] mb-8 leading-tight font-['Playfair_Display']" data-id="element-48">
        Why You Can Trust This
      </h2>
      {/* Partnership with SEPPIC */}
      <div className="bg-white p-6 rounded-lg shadow-md mb-12 border border-[#7F8C8D]/10" data-id="element-49">
        <div className="flex flex-col md:flex-row items-center justify-between" data-id="element-50">
          <div className="mb-6 md:mb-0 md:mr-8" data-id="element-51">
            <h3 className="text-xl font-semibold text-[#1B2951] mb-4 font-['Poppins']" data-id="element-52">
              In Partnership With
            </h3>
            <p className="text-[#2C3E50] mb-4 font-['Inter']" data-id="element-53">
              CERAMOSIDES™ is exclusively developed by SEPPIC, a global leader
              in cosmetic and pharmaceutical ingredients with over 80 years of
              expertise.
            </p>
          </div>
          <div className="flex-shrink-0" data-id="element-54">
            <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/tZEHutnWNwY9dYj7PPyYdb/Screenshot_2025-08-06_at_5.54.54_PM.png" alt="SEPPIC - Science That Cares" className="h-20" data-id="element-55" />
          </div>
        </div>
      </div>
      {/* First row of trust badges */}
      <div className="grid grid-cols-2 md:grid-cols-4 gap-8 mb-12" data-id="element-56">
        <div className="flex flex-col items-center" data-id="element-57">
          <div className="w-24 h-24 mb-3 rounded-full border border-[#7F8C8D]/20 flex items-center justify-center bg-white shadow-sm" data-id="element-58">
            <div className="text-center" data-id="element-59">
              <span className="block text-[#1B2951] font-bold text-2xl font-['Poppins']" data-id="element-60">
                60
              </span>
              <span className="block text-[#1B2951] text-xs font-['Poppins']" data-id="element-61">
                DAYS
              </span>
            </div>
          </div>
          <p className="text-[#1B2951] font-medium text-center font-['Poppins']" data-id="element-62">
            Money-Back
          </p>
          <p className="text-[#1B2951] font-medium text-center font-['Poppins']" data-id="element-63">
            Guarantee
          </p>
        </div>
        <div className="flex flex-col items-center" data-id="element-64">
          <div className="w-24 h-24 mb-3 rounded-full border border-[#7F8C8D]/20 flex items-center justify-center bg-white shadow-sm" data-id="element-65">
            <div className="relative w-14 h-14" data-id="element-66">
              <div className="w-full h-full flex items-center justify-center" data-id="element-67">
                <div className="w-10 h-1 bg-[#1B2951] rotate-45 absolute" data-id="element-68"></div>
                <div className="w-6 h-6 border-[3px] border-[#1B2951] rounded-full absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2" data-id="element-69"></div>
                <div className="w-8 h-[3px] bg-[#1B2951] rotate-45 absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2" data-id="element-70"></div>
              </div>
            </div>
          </div>
          <p className="text-[#1B2951] font-medium text-center font-['Poppins']" data-id="element-71">
            No
          </p>
          <p className="text-[#1B2951] font-medium text-center font-['Poppins']" data-id="element-72">
            Nasties
          </p>
        </div>
        <div className="flex flex-col items-center" data-id="element-73">
          <div className="w-24 h-24 mb-3 rounded-full border border-[#7F8C8D]/20 flex items-center justify-center bg-white shadow-sm" data-id="element-74">
            <div className="text-center" data-id="element-75">
              <span className="text-[#1B2951] text-3xl" data-id="element-76">₹</span>
              <span className="block text-[#1B2951] text-xs font-['Poppins']" data-id="element-77">
                DOWN
              </span>
            </div>
          </div>
          <p className="text-[#1B2951] font-medium text-center font-['Poppins']" data-id="element-78">
            Lowest Price
          </p>
          <p className="text-[#1B2951] font-medium text-center font-['Poppins']" data-id="element-79">
            Assured
          </p>
        </div>
        <div className="flex flex-col items-center" data-id="element-80">
          <div className="w-24 h-24 mb-3 rounded-full border border-[#7F8C8D]/20 flex items-center justify-center bg-white shadow-sm" data-id="element-81">
            <svg width="40" height="40" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" data-id="element-82">
              <path d="M16 2H8C6.9 2 6 2.9 6 4V16C6 17.1 6.9 18 8 18H16C17.1 18 18 17.1 18 16V4C18 2.9 17.1 2 16 2Z" stroke="#1B2951" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" data-id="element-83" />
              <path d="M10 6H14" stroke="#1B2951" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" data-id="element-84" />
              <path d="M12 18V22" stroke="#1B2951" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" data-id="element-85" />
              <path d="M8 22H16" stroke="#1B2951" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" data-id="element-86" />
              <path d="M11 10L10 12H14L13 14" stroke="#1B2951" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" data-id="element-87" />
            </svg>
          </div>
          <p className="text-[#1B2951] font-medium text-center font-['Poppins']" data-id="element-88">
            Free
          </p>
          <p className="text-[#1B2951] font-medium text-center font-['Poppins']" data-id="element-89">
            Shipping
          </p>
        </div>
      </div>
      {/* Second row of trust badges */}
      <div className="grid grid-cols-2 md:grid-cols-4 gap-8" data-id="element-90">
        <div className="flex flex-col items-center" data-id="element-91">
          <div className="w-24 h-24 mb-3 rounded-full border border-[#7F8C8D]/20 flex items-center justify-center bg-white shadow-sm" data-id="element-92">
            <div className="text-center" data-id="element-93">
              <span className="block text-[#1B2951] font-bold text-2xl font-['Poppins']" data-id="element-94">
                4L+
              </span>
            </div>
          </div>
          <p className="text-[#1B2951] font-medium text-center font-['Poppins']" data-id="element-95">
            Customers
          </p>
        </div>
        <div className="flex flex-col items-center" data-id="element-96">
          <div className="w-24 h-24 mb-3 rounded-full border border-[#7F8C8D]/20 flex items-center justify-center bg-white shadow-sm" data-id="element-97">
            <div className="text-center" data-id="element-98">
              <span className="block text-[#1B2951] font-bold text-lg font-['Poppins']" data-id="element-99">
                US FDA
              </span>
            </div>
          </div>
          <p className="text-[#1B2951] font-medium text-center font-['Poppins']" data-id="element-100">
            Approved
          </p>
        </div>
        <div className="flex flex-col items-center" data-id="element-101">
          <div className="w-24 h-24 mb-3 rounded-full border border-[#7F8C8D]/20 flex items-center justify-center bg-white shadow-sm" data-id="element-102">
            <div className="text-center" data-id="element-103">
              <span className="block text-[#1B2951] font-bold text-2xl font-['Poppins']" data-id="element-104">
                100+
              </span>
            </div>
          </div>
          <p className="text-[#1B2951] font-medium text-center font-['Poppins']" data-id="element-105">
            Clinical Studies
          </p>
        </div>
        <div className="flex flex-col items-center" data-id="element-106">
          <div className="w-24 h-24 mb-3 rounded-full border border-[#7F8C8D]/20 flex items-center justify-center bg-white shadow-sm" data-id="element-107">
            <div className="text-center" data-id="element-108">
              <span className="block text-[#1B2951] font-bold text-xl font-['Poppins']" data-id="element-109">
                FSSAI
              </span>
            </div>
          </div>
          <p className="text-[#1B2951] font-medium text-center font-['Poppins']" data-id="element-110">
            Certified
          </p>
        </div>
      </div>
    </section>;
}